import { ReduxState, CompetitionNavLivesState } from '../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {CompetitionNavLivesState} The Competition Nav Live state.
 */
export const liveSelector = (state) => state.competitionNavV2.live;
